import type { LangMap } from "./index";

export const states: LangMap = {
  it: {
    loading: "Caricamento…",
    loadingHint: "Ci vuole solo un istante.",
    errorTitle: "Qualcosa non ha funzionato",
    errorBody: "Non siamo riusciti a caricare questa sezione. Riprova tra un attimo.",
    retry: "Riprova",
    reload: "Ricarica la pagina",
    back: "Torna indietro",
    details: "Dettagli tecnici",
    offline: "Sembra che tu sia offline. Controlla la connessione e riprova.",
    emptyTitle: "Ancora niente qui",
    emptyBody: "Quando aggiungerai qualcosa lo troverai in questa sezione.",
    notFoundTitle: "Contenuto non trovato",
    notFoundBody: "La pagina o il contenuto che cerchi non esiste più.",
    saveError: "Salvataggio non riuscito. Riprova.",
    aiError: "L'IA non è riuscita a rispondere. Riprova.",
    authRequiredTitle: "Accesso richiesto",
    authRequiredBody: "Per vedere questa parte di Lumen devi entrare nel tuo account: i tuoi dati di studio sono protetti.",
    authRequiredCta: "Vai all'accesso",
  },
  en: {
    loading: "Loading…",
    loadingHint: "This only takes a moment.",
    errorTitle: "Something went wrong",
    errorBody: "We couldn't load this section. Please try again in a moment.",
    retry: "Try again",
    reload: "Reload page",
    back: "Go back",
    details: "Technical details",
    offline: "You appear to be offline. Check your connection and try again.",
    emptyTitle: "Nothing here yet",
    emptyBody: "Anything you add will show up in this section.",
    notFoundTitle: "Content not found",
    notFoundBody: "The page or content you're looking for no longer exists.",
    saveError: "Saving failed. Please try again.",
    aiError: "The AI couldn't answer. Please try again.",
    authRequiredTitle: "Sign in required",
    authRequiredBody: "You need to sign in to see this part of Lumen: your study data is protected.",
    authRequiredCta: "Go to sign in",
  },
  es: {
    loading: "Cargando…",
    loadingHint: "Solo tardará un momento.",
    errorTitle: "Algo ha salido mal",
    errorBody: "No hemos podido cargar esta sección. Inténtalo de nuevo en un momento.",
    retry: "Reintentar",
    reload: "Recargar la página",
    back: "Volver",
    details: "Detalles técnicos",
    offline: "Parece que no tienes conexión. Compruébala y vuelve a intentarlo.",
    emptyTitle: "Aquí todavía no hay nada",
    emptyBody: "Lo que añadas aparecerá en esta sección.",
    notFoundTitle: "Contenido no encontrado",
    notFoundBody: "La página o el contenido que buscas ya no existe.",
    saveError: "No se ha podido guardar. Inténtalo de nuevo.",
    aiError: "La IA no ha podido responder. Inténtalo de nuevo.",
    authRequiredTitle: "Se requiere iniciar sesi\u00f3n",
    authRequiredBody: "Necesitas iniciar sesi\u00f3n para ver esta parte de Lumen: tus datos de estudio est\u00e1n protegidos.",
    authRequiredCta: "Ir al inicio de sesi\u00f3n",
  },
  fr: {
    loading: "Chargement…",
    loadingHint: "Cela ne prend qu'un instant.",
    errorTitle: "Un problème est survenu",
    errorBody: "Impossible de charger cette section. Réessaie dans un instant.",
    retry: "Réessayer",
    reload: "Recharger la page",
    back: "Retour",
    details: "Détails techniques",
    offline: "Tu sembles hors ligne. Vérifie ta connexion puis réessaie.",
    emptyTitle: "Rien ici pour le moment",
    emptyBody: "Ce que tu ajouteras apparaîtra dans cette section.",
    notFoundTitle: "Contenu introuvable",
    notFoundBody: "La page ou le contenu recherché n'existe plus.",
    saveError: "Échec de l'enregistrement. Réessaie.",
    aiError: "L'IA n'a pas pu répondre. Réessaie.",
    authRequiredTitle: "Connexion requise",
    authRequiredBody: "Tu dois te connecter pour voir cette partie de Lumen : tes donn\u00e9es d'\u00e9tude sont prot\u00e9g\u00e9es.",
    authRequiredCta: "Aller \u00e0 la connexion",
  },
  de: {
    loading: "Wird geladen…",
    loadingHint: "Das dauert nur einen Moment.",
    errorTitle: "Etwas ist schiefgelaufen",
    errorBody: "Dieser Bereich konnte nicht geladen werden. Bitte versuche es gleich noch einmal.",
    retry: "Erneut versuchen",
    reload: "Seite neu laden",
    back: "Zurück",
    details: "Technische Details",
    offline: "Du scheinst offline zu sein. Prüfe die Verbindung und versuche es erneut.",
    emptyTitle: "Hier ist noch nichts",
    emptyBody: "Alles, was du hinzufügst, erscheint in diesem Bereich.",
    notFoundTitle: "Inhalt nicht gefunden",
    notFoundBody: "Die gesuchte Seite oder der Inhalt existiert nicht mehr.",
    saveError: "Speichern fehlgeschlagen. Bitte erneut versuchen.",
    aiError: "Die KI konnte nicht antworten. Bitte erneut versuchen.",
    authRequiredTitle: "Anmeldung erforderlich",
    authRequiredBody: "Melde dich an, um diesen Bereich von Lumen zu sehen: Deine Lerndaten sind gesch\u00fctzt.",
    authRequiredCta: "Zur Anmeldung",
  },
  pt: {
    loading: "A carregar…",
    loadingHint: "Demora apenas um instante.",
    errorTitle: "Algo correu mal",
    errorBody: "Não foi possível carregar esta secção. Tenta novamente dentro de momentos.",
    retry: "Tentar de novo",
    reload: "Recarregar a página",
    back: "Voltar",
    details: "Detalhes técnicos",
    offline: "Parece que estás offline. Verifica a ligação e tenta de novo.",
    emptyTitle: "Ainda não há nada aqui",
    emptyBody: "Tudo o que adicionares aparecerá nesta secção.",
    notFoundTitle: "Conteúdo não encontrado",
    notFoundBody: "A página ou o conteúdo que procuras já não existe.",
    saveError: "Não foi possível guardar. Tenta de novo.",
    aiError: "A IA não conseguiu responder. Tenta de novo.",
    authRequiredTitle: "\u00c9 necess\u00e1rio iniciar sess\u00e3o",
    authRequiredBody: "Precisas de iniciar sess\u00e3o para ver esta parte do Lumen: os teus dados de estudo est\u00e3o protegidos.",
    authRequiredCta: "Ir para o in\u00edcio de sess\u00e3o",
  },
};
